<template>
   <div>
    <div v-if="pd" class="chat" >
      <div class="chat-history" v-if="pd.Notes.length>0">
        <ul>



            <li
            :class="{ clearfix: !n.AgentFlag }"
            v-for="n in pd.Notes"
            :key="n.DFRequestDocNoteID"
          >
            <div v-if="!n.AgentFlag" class="message-data align-right">
              <span class="message-data-time mr-2" v-text="n.strDate" />
              <span class="message-data-name mr-1" v-text="n.strUserName" />
              <i class="fa fa-circle me"></i>
            </div>
            <div v-if="!n.AgentFlag" class="message other-message float-right">
              <pre class="notePre" v-text="n.Note" />
              <button style="margin-left:5px;" @click="DeleteNote(n.DFRequestDocNoteID)" class="float-right btn btn-danger">
        <i class="far fa-trash-alt"></i>
         </button>
              <button @click="EditNote(n.DFRequestDocNoteID,n.Note)" class="float-right btn btn-primary">
        <i class="far fa-edit"></i>
         </button>
            </div>

            <div class="message-data" v-if="n.AgentFlag">
              <span class="message-data-name"
                ><i class="fa fa-circle online"></i> {{ n.strUserName }}</span
              >
              <span class="message-data-time">{{ n.strDate }}</span>
            </div>
            <div class="message my-message" v-if="n.AgentFlag">
              <pre class="notePre" v-text="n.Note" />
            </div>
          </li>
        </ul>
      </div>
    </div>


    <div class="mt-3">
        
        <v-row>
      <v-col cols="12">
         


<v-textarea
          outlined 
          :label="$t('labels.TypeMessage')"
              v-model="frm.Note"
        ></v-textarea>
      </v-col>
        </v-row>
      <br />
      
      
       <v-btn :disabled="!frm.Note" @click="addNote" color="primary" class="float-right mx-auto mb-4">
        {{ $t("labels.AddNote") }}
       </v-btn>
      
      
       
      <br clear="all" />
    </div>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline" v-text="$t('labels.EditNote')"></span>
        </v-card-title>
         <v-card-text>
             <v-container>           
            <v-row>
              <v-col cols="12">
                <v-textarea
          outlined 
          :label="$t('labels.TypeMessage')"
              v-model="editnote"
        ></v-textarea>
              </v-col>
            </v-row>
             </v-container>
         </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogClose">{{$t('labels.Close')}}</v-btn>
          <v-btn color="blue darken-1" text @click="dialogSave">{{$t('labels.Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import dataSvc from "@/services/dataService";
export default {
    props:["requestDocID","siteID"],
    data(){
        return {
            loadFlag: false,
            noteID: null,
            editnote: null,
            EditNoteFlag: false,
            dialog: false,
            pd:null,
            frm:{
                Note:null
            }           
        }
    },
    methods:{
       dialogClose() {
      this.dialog = false;
    },
     dialogSave() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
         NoteID: this.noteID,            
         RequestDocID: this.requestDocID,
         Note: this.editnote
      };
     
      dataSvc
            .getHttp()
            .post("/api/RDEditNote", postData)
            .then(res => {
              this.loadPage();
            });
           

      this.dialog = false;
    },
       DeleteNote(noteID){
         this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteNote"),
        () => {
         let postData = {
            SiteID: this.siteID,
            RequestDocNoteID: noteID,
            RequestDocID: this.requestDocID
          };
           this.loadFlag = true;
         dataSvc
            .getHttp()
            .post("/api/RDDeleteNote", postData)
            .then(res => {
              this.loadPage();
            });          
        },
        () => {}
      );     
    },
    EditNote(noteID, note){
      this.editnote = note;
      this.noteID = noteID;
      this.dialog =true;
    },
        addNote(){
           if (!this.frm.Note) return;
            let postData = {
                SiteID: this.siteID,
                RequestDocID: this.requestDocID,
                Note: this.frm.Note
            };
            this.loadFlag = true;
            dataSvc
                .getHttp()
                .post("/api/RDAddNote", postData)
                .then(res => {
                    this.loadFlag = false;
                    this.loadPage();
                });
        },
        loadPage(){
            this.loadFlag = true;
            let postData ={
                SiteID: this.siteID,
                RequestDocID: this.requestDocID
            };
            dataSvc.getHttp().post('/api/RDLoadNotes',postData).then(res=>{
                this.pd = res.data;
                this.loadFlag = false;
                this.frm.Note = null;
            });
        }
    },
    created(){
        this.loadPage();
    }
}
</script>

<style lang="scss" scoped>
$green: #86bb71;
$blue: #94c2ed;
$orange: #e38968;
$gray: #92959e;



.notePre{
  color: white;
  overflow-x: auto;
            white-space: pre-wrap;
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            word-wrap: break-word;
}

.people-list {
  width: 260px;
  float: left;

  .fa-search {
    position: relative;
    left: -25px;
  }

  ul {
    padding: 20px;
    height: 770px;

    li {
      padding-bottom: 20px;
    }
  }

  img {
    float: left;
  }

  .about {
    float: left;
    margin-top: 8px;
  }

  .about {
    padding-left: 8px;
  }

  .status {
    color: $gray;
  }
}

.chat {
  width: 100%;
  float: left;
  background: #f2f5f8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

  color: #434651;

  .chat-header {
    padding: 20px;
    border-bottom: 2px solid white;

    img {
      float: left;
    }

    .chat-about {
      float: left;
      padding-left: 10px;
      margin-top: 6px;
    }

    .chat-with {
      font-weight: bold;
      font-size: 16px;
    }

    .chat-num-messages {
      color: $gray;
    }

    .fa-star {
      float: right;
      color: #d8dadf;
      font-size: 20px;
      margin-top: 12px;
    }
  }

  .chat-history {
    padding: 30px 30px 20px;
    border-bottom: 2px solid white;
    
    

    ul {
      list-style: none;
    }
    .message-data {
      margin-bottom: 15px;
    }

    .message-data-time {
      color: lighten($gray, 8%);
      padding-left: 6px;
    }

    .message {
      color: white;
      padding: 18px 20px;
      line-height: 26px;
      font-size: 16px;
      border-radius: 7px;
      margin-bottom: 30px;
      width: 90%;
      position: relative;

      &:after {
        bottom: 100%;
        left: 7%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-bottom-color: $green;
        border-width: 10px;
        margin-left: -10px;
      }
    }

    .my-message {
      background: $green;
    }

    .other-message {
      background: $blue;

      &:after {
        border-bottom-color: $blue;
        left: 93%;
      }
    }
  }

  .chat-message {
    padding: 30px;

    textarea {
      width: 100%;
      border: none;
      padding: 10px 20px;
      font: 14px/22px "Lato", Arial, sans-serif;
      margin-bottom: 10px;
      border-radius: 5px;
      resize: none;
    }

    .fa-file-o,
    .fa-file-image-o {
      font-size: 16px;
      color: gray;
      cursor: pointer;
    }

    button {
      float: right;
      color: $blue;
      font-size: 16px;
      text-transform: uppercase;
      border: none;
      cursor: pointer;
      font-weight: bold;
      background: #f2f5f8;

      &:hover {
        color: darken($blue, 7%);
      }
    }
  }
}

.online,
.offline,
.me {
  margin-right: 3px;
  font-size: 10px;
}

.online {
  color: $green;
}

.offline {
  color: $orange;
}

.me {
  color: $blue;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.float-right {
  float: right;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
</style>
